import map from 'lodash/map';

import {
  AllLaborLevelsResponse,
  LaborLevelResponse,
  LaborLevelsLevelResponse,
} from '@sbv-clients/data-access-api';

export const defaultGetLaborLevelLabel = (
  item: LaborLevelsLevelResponse
): string => item.levelName ?? '';

export const defaultGetLaborLevelLevelLabel = (
  child: LaborLevelResponse
): string => child.laborLevelDescription ?? '';

export const buildLaborLevelOptions = ({
  levelDefinitions,
  laborLevels,
  getLaborLevelLabel = defaultGetLaborLevelLabel,
  getLaborLevelLevelLabel = defaultGetLaborLevelLevelLabel,
}: {
  levelDefinitions: AllLaborLevelsResponse['laborLevelsLevelResponse'];
  laborLevels: AllLaborLevelsResponse['laborLevels'];
  getLaborLevelLabel?: (item: LaborLevelsLevelResponse) => string;
  getLaborLevelLevelLabel?: (child: LaborLevelResponse) => string;
}) => {
  return map(levelDefinitions, (item) => ({
    id: item.level,
    label: getLaborLevelLabel(item),
    value: item.level,
    meta: item,
    children: laborLevels?.[item.level]
      ?.filter((item) => Boolean(item.laborLevelDescription))
      .map((child) => ({
        id: child.pkLaborLevelId as number,
        value: child.pkLaborLevelId as number,
        label: getLaborLevelLevelLabel(child),
        inActive: child.inactive,
        meta: child,
      })),
  }));
};
